import React, { memo } from 'react'
import { TextField } from '@mui/material'
import PropTypes from 'prop-types'

const TextFieldAdapter = memo(({ input, meta, ...rest }) => (
  <TextField
    {...input}
    {...rest}
    error={meta.touched && meta.error}
    helperText={meta.touched && meta.error}
    fullWidth
  />
))

TextFieldAdapter.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }).isRequired
}

TextFieldAdapter.displayName = 'TextFieldAdapter'

export default TextFieldAdapter
